@import "../../global/normalize.css";

/**
 * @prop --ic-z-index-tooltip: z-index of tooltip
 */

:host(.ic-tooltip) {
  width: max-content;
  height: max-content;

  --ic-tooltip-background: var(--ic-color-background-primary-dark);
  --ic-tooltip-text: var(--ic-color-text-primary-dark);
  --ic-tooltip-border: var(--ic-color-border-neutral-grey-light);
}

:host(.ic-tooltip) .ic-tooltip-container {
  background-color: var(--ic-tooltip-background);
  text-align: center;
  padding: var(--ic-space-xxxs) var(--ic-space-xs);
  border-radius: var(--ic-border-radius);
  border: var(--ic-border-width) solid var(--ic-tooltip-border);
  position: absolute;
  max-width: 20rem;
  display: none;
  z-index: var(--ic-z-index-tooltip);
  box-shadow: var(--ic-elevation-overlay);
  width: max-content;
}

:host(.ic-tooltip) ic-typography {
  --ic-typography-color: var(--ic-tooltip-text);
}

:host(.tooltip-navigation-item:not(.tooltip-navigation-item-side-nav-collapsed))
  .ic-tooltip-container,
:host(.tooltip-disabled) .ic-tooltip-container {
  display: none !important;
}

:host(.tooltip-long-label-navigation-item-side-nav-expanded)
  .ic-tooltip-container[data-show] {
  display: block !important;
}

:host(.ic-tooltip) .ic-tooltip-arrow,
:host(.ic-tooltip) .ic-tooltip-arrow::before {
  position: absolute;
  background: inherit;
}

:host(.ic-tooltip) .ic-tooltip-arrow {
  visibility: hidden;
  width: var(--ic-space-md);
  height: var(--ic-space-md);
}

:host(.ic-tooltip) .ic-tooltip-arrow::before {
  visibility: visible;
  content: "";
  border: var(--ic-border-width) solid var(--ic-tooltip-border);
  width: 100%;
  height: 100%;
}

:host(.ic-tooltip) .ic-tooltip-container[data-show] {
  display: block;
}

:host(.ic-tooltip)
  .ic-tooltip-container[data-popper-placement^="top"]
  > .ic-tooltip-arrow {
  height: var(--ic-space-xxxs);
}

:host(.ic-tooltip)
  .ic-tooltip-container[data-popper-placement^="top"]
  > .ic-tooltip-arrow::before {
  border-radius: 0 0 var(--ic-border-radius) var(--ic-border-radius);
  left: 0;
  top: var(--ic-space-xxxs);
  border-top: 0;
  transform: translateX(var(--tooltip-arrow-translate));
}

:host(.ic-tooltip)
  .ic-tooltip-container[data-popper-placement^="bottom"]
  > .ic-tooltip-arrow {
  top: calc(-1 * var(--ic-space-xxs));
  height: var(--ic-space-xxxs);
}

:host(.ic-tooltip)
  .ic-tooltip-container[data-popper-placement^="bottom"]
  > .ic-tooltip-arrow::before {
  border-radius: var(--ic-border-radius) var(--ic-border-radius) 0 0;
  left: 0;
  top: var(--ic-space-1px);
  border-bottom: 0;
  transform: translateX(var(--tooltip-arrow-translate));
}

:host(.ic-tooltip)
  .ic-tooltip-container[data-popper-placement^="left"]
  > .ic-tooltip-arrow {
  width: var(--ic-space-xxxs);
  right: calc(-1 * var(--ic-space-1px));
}

:host(.ic-tooltip)
  .ic-tooltip-container[data-popper-placement^="left"]
  > .ic-tooltip-arrow::before {
  border-radius: 0 var(--ic-border-radius) var(--ic-border-radius) 0;
  border-left: 0;
  top: calc(-1 * var(--ic-space-1px));
}

:host(.ic-tooltip)
  .ic-tooltip-container[data-popper-placement^="right"]
  > .ic-tooltip-arrow {
  width: var(--ic-space-xxxs);
  left: calc(-1 * var(--ic-space-xxs));
}

:host(.ic-tooltip)
  .ic-tooltip-container[data-popper-placement^="right"]
  > .ic-tooltip-arrow::before {
  border-radius: var(--ic-border-radius) 0 0 var(--ic-border-radius);
  border-right: 0;
  top: calc(-1 * var(--ic-space-1px));
}

:host(.ic-tooltip-in-container) {
  display: inline-block;
}

:host(.ic-tooltip.ic-tooltip-with-icon) .ic-tooltip-content {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--ic-space-xxs);
  text-align: left;
}

:host(.ic-tooltip.ic-tooltip-with-icon) .ic-icon-container {
  width: var(--ic-space-md);
  height: var(--ic-space-md);
  color: var(--ic-tooltip-text);
}

:host(.ic-tooltip.ic-tooltip-with-icon) ::slotted([slot="icon"]) {
  width: var(--ic-space-md);
  height: var(--ic-space-md);
  display: inline-block;
  margin-top: var(--ic-space-1px);
}

@media screen and (max-width: 576px) {
  :host(.ic-tooltip) .ic-tooltip-container {
    max-width: 18.875rem;
  }
}

@media (forced-colors: active) {
  :host(.ic-tooltip) .ic-tooltip-container,
  :host(.ic-tooltip) .ic-tooltip-arrow::before {
    border: var(--ic-border-hc);
  }
}
